import React from 'react'
import { AiFillProfile, AiFillHome, AiFillCustomerService } from 'react-icons/ai'
import {
    SidebarContainer,
    SidebarWrap,
    Icon,
    CloseIcon,
    SidebarLink,
    SidebarMenu
} from './SidebarElement'

const Sidebar = (props) => {
    return (
        <>
            <SidebarContainer isOpen={props.isOpen}>
                <SidebarWrap>
                    <Icon onClick={props.toggle}>
                        <CloseIcon />
                    </Icon>
                    <SidebarMenu>
                        <SidebarLink to='/' onClick={props.toggle}>
                            <AiFillHome /> Home
                        </SidebarLink>

                        <SidebarLink to='/about' onClick={props.toggle}>
                            <AiFillProfile /> About Us
                        </SidebarLink>

                        <SidebarLink to='/services' onClick={props.toggle}>
                            <AiFillProfile /> Services
                        </SidebarLink>

                        <SidebarLink to='/contact' onClick={props.toggle}>
                            <AiFillCustomerService /> Contact Us
                        </SidebarLink>
                    </SidebarMenu>
                </SidebarWrap>
            </SidebarContainer>
        </>
    )
}

export default Sidebar